import { useFullFreeshipping } from '../../../components/context/full-freeshipping';

export default useFullFreeshipping;
